import { useState, useEffect, useCallback } from 'react';
import safeLocalStorage from '../safeLocalStorage/index';
var useLocalStorageValue = function (key, initialValue) {
    var _a = useState(function () {
        // Fetch the value from localStorage
        var item = safeLocalStorage.getItem(key);
        // If initialValue is provided, use it and update localStorage accordingly
        if (initialValue !== undefined) {
            safeLocalStorage.setItem(key, JSON.stringify(initialValue));
            return initialValue;
        }
        return item ? JSON.parse(item) : null;
    }), storedValue = _a[0], setStoredValue = _a[1];
    var setValue = useCallback(function (value) {
        var valueString = JSON.stringify(value);
        safeLocalStorage.setItem(key, valueString);
        setStoredValue(value);
    }, [key]);
    useEffect(function () {
        var handleStorageChange = function () {
            var item = safeLocalStorage.getItem(key);
            setStoredValue(item ? JSON.parse(item) : null);
        };
        window.addEventListener('storage', handleStorageChange);
        return function () {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [key]);
    return [storedValue, setValue];
};
export default useLocalStorageValue;
